'use client';

import { c as _c } from "react/compiler-runtime";
import { AccordionContent, AccordionItem, AccordionTrigger } from '@uzh-bf/design-system';
import UnitAccordionClient from '~/components/UnitAccordionClient';
import UnitOverviewContent from '~/components/UnitOverviewContent';
import UnitOverviewHeader from '~/components/UnitOverviewHeader';
import { CourseUnit } from '~/payload-types';
export default function UnitAccordion(t0) {
  const $ = _c(14);
  const {
    linkDisabled: t1,
    modulePath,
    units,
    moduleNumber
  } = t0;
  const linkDisabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== units) {
    t2 = units.filter(_temp).map(_temp2);
    $[0] = units;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const unitIds = t2;
  let t3;
  if ($[2] !== linkDisabled || $[3] !== moduleNumber || $[4] !== modulePath || $[5] !== units) {
    let t4;
    if ($[7] !== linkDisabled || $[8] !== moduleNumber || $[9] !== modulePath) {
      t4 = (unit_1, ix) => {
        if (typeof unit_1 === "number") {
          return null;
        }
        return <UnitAccordionItem key={unit_1.id} modulePath={modulePath} unit={unit_1} number={ix + 1} linkDisabled={linkDisabled} moduleNumber={moduleNumber} />;
      };
      $[7] = linkDisabled;
      $[8] = moduleNumber;
      $[9] = modulePath;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = units.map(t4);
    $[2] = linkDisabled;
    $[3] = moduleNumber;
    $[4] = modulePath;
    $[5] = units;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[11] !== t3 || $[12] !== unitIds) {
    t4 = <UnitAccordionClient unitIds={unitIds}>{t3}</UnitAccordionClient>;
    $[11] = t3;
    $[12] = unitIds;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp2(unit_0) {
  return String(unit_0.id);
}
function _temp(unit) {
  return typeof unit !== "number";
}
function UnitAccordionItem(t0) {
  const $ = _c(14);
  const {
    linkDisabled,
    modulePath,
    unit,
    number,
    moduleNumber
  } = t0;
  const t1 = `unit-${unit.id}`;
  const t2 = String(unit.id);
  let t3;
  if ($[0] !== linkDisabled || $[1] !== moduleNumber || $[2] !== modulePath || $[3] !== number || $[4] !== unit) {
    t3 = <AccordionTrigger className="relative gap-0 p-0 pr-6 hover:no-underline [&>svg]:absolute [&>svg]:right-0 [&>svg]:top-2 sm:[&>svg]:top-2.5"><UnitOverviewHeader modulePath={modulePath} unit={unit} number={number} linkDisabled={linkDisabled} moduleNumber={moduleNumber} /></AccordionTrigger>;
    $[0] = linkDisabled;
    $[1] = moduleNumber;
    $[2] = modulePath;
    $[3] = number;
    $[4] = unit;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== modulePath || $[7] !== unit) {
    t4 = <AccordionContent><UnitOverviewContent unit={unit} modulePath={modulePath} showWeiterButton={false} /></AccordionContent>;
    $[6] = modulePath;
    $[7] = unit;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <AccordionItem id={t1} value={t2} className="scroll-mt-6 data-[state=open]:border-primary-100 data-[state=open]:border-t-4 data-[state=open]:pt-0.5 border-t border-b-0 px-2 py-1.5 hover:border-black sm:py-2">{t3}{t4}</AccordionItem>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}